import type { ReceiptTemplate } from '../schema';

export const nordstromTemplate: ReceiptTemplate = {
  id: 'nordstrom',
  name: 'Nordstrom Receipt',
  brand: 'NORDSTROM',
  description: 'Department store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'nord-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/nordstrom.png',
        logoData: '',
        logoWidth: 150,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'nord-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'nord-date', label: 'Date:', value: '01/04/2026' },
          { id: 'nord-trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'nord-time', label: 'Time:', value: '15:42' },
          { id: 'nord-assoc', label: 'Sales:', value: 'JAMES S.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nord-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'nord-item-1', name: 'TOPMAN BLAZER', quantity: '1', price: '175.00'},
          { id: 'nord-item-2', name: 'POLO RALPH LAUREN SHIRT', quantity: '1', price: '98.50'},
          { id: 'nord-item-3', name: 'COLE HAAN LOAFERS', quantity: '1', price: '150.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nord-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'nord-subtotal', label: 'Subtotal', value: '423.50', isBold: false, isLarge: false },
          { id: 'nord-tax', label: 'Tax', value: '37.59', isBold: false, isLarge: false },
          { id: 'nord-total', label: 'Total', value: '461.09', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'nord-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'nord-card', label: 'NORDSTROM CARD', value: '************4144' },
          { id: 'nord-auth', label: 'Auth', value: '284719' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'nord-rewards',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'NORDY CLUB MEMBER\nPOINTS EARNED: 461\nNORDSTROM NOTES: $20.00 AVAILABLE',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'nord-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '847291010426',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'nord-return',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'We handle returns on a case-by-case\nbasis. Visit nordstrom.com/returns',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

